// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundingMethodTypePropertyDto
 */
export interface IFundingMethodTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IFundingMethodTypePropertyDto
     */
    funding_method_type?: IFundingMethodTypePropertyDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IFundingMethodTypePropertyDto
     */
    funding_method_type_state?: IFundingMethodTypePropertyDtoFundingMethodTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IFundingMethodTypePropertyDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IFundingMethodTypePropertyDtoFundingMethodTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IFundingMethodTypePropertyDto interface.
 */
export function instanceOfIFundingMethodTypePropertyDto(value: object): value is IFundingMethodTypePropertyDto {
    return true;
}

export function IFundingMethodTypePropertyDtoFromJSON(json: any): IFundingMethodTypePropertyDto {
    return IFundingMethodTypePropertyDtoFromJSONTyped(json, false);
}

export function IFundingMethodTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundingMethodTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'funding_method_type_state': json['funding_method_type_state'] == null ? undefined : json['funding_method_type_state'],
    };
}

export function IFundingMethodTypePropertyDtoToJSON(json: any): IFundingMethodTypePropertyDto {
    return IFundingMethodTypePropertyDtoToJSONTyped(json, false);
}

export function IFundingMethodTypePropertyDtoToJSONTyped(value?: IFundingMethodTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'funding_method_type': value['funding_method_type'],
        'funding_method_type_state': value['funding_method_type_state'],
    };
}

